/*
 * 1DS JSLL SKU, 3.1.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 * (Microsoft Internal Only)
 */
/**
* Logger.ts
* @author Hector Hernandez (hectorh)
* @copyright Microsoft 2020
* JSLL Logger.
*/
var Logger = /** @class */ (function () {
    function Logger(sku) {
        this._sku = sku;
    }
    Logger.prototype.logError = function (message) {
        // console.warn will be used always if available, console.log is fallback
        this._sku.logger.warnToConsole(message);
    };
    Logger.prototype.logWarning = function (message) {
        // console.warn will be used always if available, console.log is fallback
        this._sku.logger.warnToConsole(message);
    };
    Logger.prototype.logInformation = function (message) {
        // console.warn will be used always if available, console.log is fallback
        this._sku.logger.warnToConsole(message);
    };
    return Logger;
}());
export { Logger };
//# sourceMappingURL=Logger.js.map